/**
 * Alaska: App.js (PWA)
 * Store: User
 * @version 1.0
 */

document.addEventListener("alpine:init", () => {
    Alpine.store("user", {
        logged_in: false,
        ready: false,
        is_admin: false,

        driver: null,
        company: null,
        schedule: null,
        animation: false,
        loading: false,

        async init() {
            if (this.driver !== null) return;

            try {
                const res = await fetch("/", {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({
                        action: "auth",
                        controller: "authentication",
                    })
                });

                const json = await res.json();

                console.log(json)

                this.logged_in = json.type === "success";

                if (json.user !== undefined) {
                    console.log(json.user);

                    this.driver = json.user.driver ?? null;
                    this.company = json.user.company ?? null;
                    this.schedule = json.user.schedule ?? null;

                    this.is_admin = json.permissions === 2;
                }

            } catch (error) {
                console.error("Auth check failed:", error);
            } finally {
                this.ready = true;
            }
        },

        logout()
        {
            this.driver = null;
            this.company = null;
            this.schedule = null;

            console.log("User logged out.")
        },

        async fetch_schedule() {
            Loading.show();

            this.schedule = [];
            this.animation = true;

            this.loading = true;

            try {
                const res = await fetch("/", {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({
                        action: "fetch_schedule",
                        controller: "account",
                        data: {
                            email: this.driver?.email,
                        }
                    })
                });

                const json = await res.json();

                if (json.data !== undefined) {
                    this.schedule = json.data;
                }

                console.log(this.schedule);

            } catch (error) {
                console.error("An error occurred while fetching the schedule", error);
            } finally {
                this.loading = false;
                Loading.hide();
            }
        }

    });
});